module.exports = __webpack_public_path__ + "img/rule_04.f0383693.png";